<template>
	<div id="">
		<div class="dis-flex">
			<div class="add-box dis-flex">
				<el-form
				  size="small"
				  :model="ruleForm"
				  :hide-required-asterisk="false"
				  ref="ruleForm"
				  class="demo-ruleForm"
				>
					<el-form-item label="标题">
					  <el-input
						placeholder="请输入文章标题"
						v-model="ruleForm.title"
					  ></el-input>
					</el-form-item>
					<el-form-item label="副标题">
					  <el-input
						placeholder="请输入文章副标题"
						v-model="ruleForm.sub_title"
					  ></el-input>
					</el-form-item>
					<el-form-item label="状态">
						<el-radio-group v-model="ruleForm.status">
						  <el-radio label="1"  >启用</el-radio>
						  <el-radio label="0" >禁用</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="排序">
					  <el-input
						type="number"
						placeholder="请输入图片排序"
						v-model="ruleForm.sort"
					  ></el-input>
					</el-form-item>
					<el-form-item label="文章封面" >
						<el-upload
						  :on-success="onSuccess"
						  :action="action"
						  :limit="1"
						  :before-upload="beforeUpload"
						  :multiple="true"
						  :file-list="fileList"
						  list-type="picture-card"
						  :on-preview="handlePictureCardPreview"
						  :on-remove="handleRemove">
						  <i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="内容">
						<quill-editor class="myQuillEditor "
							v-model="ruleForm.content" 
							:options="quillOption">
						</quill-editor>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="row1">
		  <!-- <div> -->
		    <el-button
		      @click="submit('ruleForm')"
		      class="row-btn add"
		      type="primary"
		      size="small"
		      >{{type == 1?'提交':'修改'}}</el-button>
		    <el-button
		      @click="back"
		      class="row-btn add back"
		      type="primary"
		      size="small"
		      >返回</el-button
		    >
		  <!-- </div> -->
		</div>
	</div>
</template>

<script>
import * as imageConversion from 'image-conversion'
import quillConfig from './quill-config.js'
export default {
	data(){
		return{
			quillOption: '',
			editorOption: {
				theme: "snow", // 默认主题
				placeholder: "请编辑文章内容", 
			} ,
			fileList:[],
			ruleForm: {
			  title: "",
			  sub_title:"",
			  status: '1',
			  content:"",
			  sort:'',
			  image: '',
			},
		}
	},
	created() {
		this.action = this.$baseUrl + '/admin/ajax/upload?PHPSESSID='+this.getCookie('PHPSESSID')
		this.type = this.$route.query.type //1为添加，2为修改
		if(this.$route.query.type == 2){
			for(let key in this.ruleForm){
				this.ruleForm[key] = this.$route.query[key]
			}
			this.fileList[0] = {
				url:this.ruleForm.image,
			} 
			this.ruleForm.id = this.$route.query.id
			this.ruleForm.content = this.escapeStringHTML(this.ruleForm.content)
		}
		
		let config = {
		    action:  this.action,  // 必填参数 图片上传地址
		    methods: 'POST',  // 必填参数 图片上传方式
		    // token: '',  // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
		    name: 'file',  // 必填参数 文件的参数名
		    // size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
		    accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon'  // 可选 可上传的图片格式
		};
		this.quillOption = quillConfig(config) //转译文章内容
	},
	methods:{
		beforeUpload(file){
			return new Promise((resolve, reject) => {
			  	imageConversion.compress(file,0.8).then(res => { 
			  	  console.log(file);
			  	  resolve(res)
			  	})
			})
			// return new Promise((resolve, reject) => {
			// 	let isLt2M = file.size / 1024 / 1024 < 4 // 判定图片大小是否小于4MB
			// 	console.log(isLt2M);
			// 	if (isLt2M) {
			// 	   resolve(file)
			// 	}else{
			// 		// console.log(file) // 压缩到400KB,这里的400就是要压缩的大小,可自定义
			// 		imageConversion.compressAccurately(file, 400).then(res => { // console.log(res)
			// 		  console.log(file);
			// 		  resolve(res)
			// 		})
			// 	}
			// })
		},
		escapeStringHTML(str) {
		　　str = str.replace(/&lt;/g,'<');
		　　str = str.replace(/&gt;/g,'>');
			str = str.replace(/&quot;/gi, '"')
		　　return str;
	　　},
		//上传图片回调
		onSuccess(response, file, fileList){
			this.addOrDel = true;
			// this.ruleForm.images = []
			fileList.forEach((v,k)=>{
				if(v.id){
					// this.ruleForm.images.push(v.url)
						this.ruleForm.image = v.url
				}else{
					let response = v.response
					if(response.code == 1){
						// this.ruleForm.images.push(response.data.url)
							this.ruleForm.image = response.data.url
					}else{
						this.$message.error(res.msg)
					}
				}
			})
			console.log(this.ruleForm.image);
		},
		//移除图片
		handleRemove(file, fileList) {
			this.addOrDel = true;
			console.log(file, fileList);
			this.ruleForm.image = ''
			fileList.forEach((v,k)=>{
				if(v.id){
					// this.ruleForm.images.push(v.id)
						this.ruleForm.image = v.url
				}else{
					let response = v.response
					if(response.code == 1){
						// this.ruleForm.images.push(response.data.id)
							this.ruleForm.image = response.data.url
					}else{
						this.$message.error(res.msg)
					}
				}
			})
			console.log('-------移除后-------');
			console.log(this.ruleForm.image);
		  },
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.diaVisible = true;
		},
		// 返回
		back(){
		  this.$router.go(-1)
		},
		submit(formName){
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				console.log(this.ruleForm);
				if(!this.ruleForm.image){
					return this.$message.error('请上传图片')
				}
				console.log(this.ruleForm);
				//1为添加，2为修改
			    if(this.type == 1){
					  this.$api2.addArticle(this.ruleForm).then((res)=>{
						if(res.code == 1){
							this.$message.success(res.msg)
							setTimeout(()=>{
								// this.$router.push({ path: "/sys_setMeal_index"});
								this.$router.go(-1)
							},1.5e3)
						}else{
							this.$message.error(res.msg)
						}
					  })
				  }else if(this.type == 2){
					  this.$api2.editArticle(this.ruleForm).then((res)=>{
						if(res.code == 1){
							this.$message.success(res.msg)
							setTimeout(()=>{
								// this.$router.push({ path: "/sys_setMeal_index"});
								this.$router.go(-1)
							},1.5e3)
						}else{
							this.$message.error(res.msg)
						}
					  })
				  }
			  } else {
			    this.$message.error("请输入必填项！");
			    return false;
			  }
			});
		},
		// 获取cookie
		getCookie(name) {
		 var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
		 if (arr = document.cookie.match(reg))
		  return (arr[2]);
		 else
		  return null;
		},
	}
}
</script>

<style lang="scss" scoped="scoped">
.myQuillEditor{
	height: 400px;
	width: 500px;
}
.row1{
	width: 25vw;
	margin-top: 100px;
	padding-left: 60px;
	.add{
		margin: 0 auto;
		width: 10vw;
	}
}
</style>
<style lang="scss" scoped>
.row1 {
  padding-top: 20px;
  .add {
    padding: 12px 35px;
  }
  .back{
    background-color: #fff;
    color: gray;
    border: 1px solid #DCDFE6;
  }
}
.add-box /deep/ {
  .title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .el-input {
    width: 500px;
  }
  .el-form-item {
    padding-left: 0 !important;
  }
  .el-form-item__content {
    margin-left: 75px !important;
  }
  .el-form-item__label {
    height: 30px;
    width: 60px !important;
    text-align: justify;
  }
  .el-form-item__label:after {
    display: inline-block;
    content: "";
    padding-left: 100%;
  }
  .el-form-item {
    padding: 10px 30px;
  }
}
/* 去除验证的红色星号 */
.dis-flex
  /deep/
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: " ";
  width: 0px;
  margin-right: 0px;
}
</style>
